export default "__VITE_ASSET__8a2b7b04__"